const Circle = (props) =>{
    const classes = "rounded-full border-12 circle m-auto flex align-center justify-center " + props.className;
    return(
        <div  className={classes}>
            {props.children}
        </div>
    )
}
export default Circle